/** Eigenes Lagerfeuer-Logo (Flamme über gekreuzten Scheiten). */
export function Logo({ size = 40, title = 'Lagerfeuer' }: { size?: number; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={title} data-testid="lf-logo">
      <defs>
        <linearGradient id="lf-flame" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#e2452b" />
          <stop offset="0.55" stopColor="#ff7a18" />
          <stop offset="1" stopColor="#ffb347" />
        </linearGradient>
      </defs>
      <path d="M32 6c4 10 14 14 14 28a14 14 0 0 1-28 0c0-8 4-12 7-16 1 5 3 7 5 8-1-8 0-14 2-20z" fill="url(#lf-flame)" />
      <path d="M32 30c2 5 7 7 7 13a7 7 0 0 1-14 0c0-4 3-6 4-9 1 2 2 3 3 3z" fill="#ffd166" />
      <rect x="14" y="52" width="36" height="5" rx="2.5" fill="#6b4a2f" transform="rotate(-12 32 54)" />
      <rect x="14" y="52" width="36" height="5" rx="2.5" fill="#7d5838" transform="rotate(12 32 54)" />
    </svg>
  );
}
